export default {
  gu: "invalid_api_key",
  bu: "blacklisted",
  qu: "no_device_identifier",
  Ru: "invalid_json_response",
  vu: "empty_response",
  __: "sdk_auth_error"
};